<template>
    <v-card>
        <v-card-title>
             {{ item.firstname }} {{ item.lastname }}
        </v-card-title>
        <v-card-text>
            <v-list
                subheader
                two-line
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>
                            mdi-gender-transgender
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.gender }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Gender
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>
                            mdi-account-details
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.firstname }} / {{ item.lastname }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Firstname / Surname
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    v-if="index === 0 && booking.user.country"
                >
                    <v-list-item-icon>
                        <v-icon>
                            mdi-earth
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ booking.user.country }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Nationality
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>
                            mdi-cake-variant
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ new Date(item.birthday).toLocaleDateString() }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Birthdate
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                        v-if="index === 0 && booking.status === 1 && booking.user.street"
                >
                    <v-list-item-icon>
                        <v-icon>
                            mdi-map-marker
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{booking.user.street}}, {{booking.user.zip}} {{booking.user.city}}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Address
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    v-if="index === 0 && booking.status === 1 && booking.user.telephone"
                >
                    <v-list-item-icon>
                        <v-icon>
                            mdi-phone
                        </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ booking.user.telephone }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Phone
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <passport
                    v-if="item.passport"
                    :passport="item.passport"
                >
                </passport>
                <emergency-contact
                    v-if="item.emergencyContact"
                    :contact="item.emergencyContact"
                >
                </emergency-contact>
                <board
                    v-if="item.board"
                    :board="item.board"
                >
                </board>
                <bike
                    v-if="item.bike"
                    :bike="item.bike"
                >
                </bike>
                <extensions
                    v-if="item.accommodations && item.accommodations.length > 0"
                    :extensions="item.accommodations"
                >
                </extensions>
                <transfers
                    v-if="item.transfers && item.transfers.length > 0"
                    :transfers="item.transfers"
                >
                </transfers>
                <equipments
                    v-if="item.equipments && item.equipments.length > 0"
                    :equipments="item.equipments"
                >
                </equipments>
                <dog
                    v-if="item.dogs && item.dogs.length > 0"
                    :dogs="item.dogs"
                >
                </dog>
                <flights
                    v-if="item.flights && item.flights.length > 0"
                    :flights="item.flights"
                >
                </flights>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
    import Passport from "./Passport";
    import EmergencyContact from "./EmergencyContact";
    import Board from "./Board";
    import Bike from "./Bike";
    import Extensions from "./Extensions";
    import Transfers from "./Transfers";
    import Equipments from "./Equipments";
    import Dog from "./Dog";
    import Flights from "./Flights";

    export default {
        components: {
            Passport,
            EmergencyContact,
            Board,
            Bike,
            Extensions,
            Transfers,
            Equipments,
            Dog,
            Flights,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            booking: {
                type: Object,
                required: true,
            },
            index: {
                type: Number,
                default: 0,
            },
        },
    }
</script>
